// Generated by purs version 0.14.3
"use strict";
var Control_Applicative = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/prelude/v5.0.1/src/Control/Applicative.purs");
var Control_Monad_Writer_Class = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/transformers/v5.2.0/src/Control/Monad/Writer/Class.purs");
var Control_Monad_Writer_Trans = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/transformers/v5.2.0/src/Control/Monad/Writer/Trans.purs");
var Data_Identity = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/identity/v5.0.0/src/Data/Identity.purs");
var Data_Newtype = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/newtype/v4.0.0/src/Data/Newtype.purs");
var Data_Tuple = require("/Users/mengwong/src/smucclaw/vue-pure-pdpa/.spago/tuples/v6.0.1/src/Data/Tuple.purs");
var writer = (function () {
    var $0 = Control_Applicative.pure(Data_Identity.applicativeIdentity);
    return function ($1) {
        return Control_Monad_Writer_Trans.WriterT($0($1));
    };
})();
var runWriter = (function () {
    var $2 = Data_Newtype.unwrap();
    return function ($3) {
        return $2(Control_Monad_Writer_Trans.runWriterT($3));
    };
})();
var mapWriter = function (f) {
    return Control_Monad_Writer_Trans.mapWriterT((function () {
        var $4 = Data_Newtype.unwrap();
        return function ($5) {
            return Data_Identity.Identity(f($4($5)));
        };
    })());
};
var execWriter = function (m) {
    return Data_Tuple.snd(runWriter(m));
};
module.exports = {
    writer: writer,
    runWriter: runWriter,
    execWriter: execWriter,
    mapWriter: mapWriter,
    MonadTell: Control_Monad_Writer_Class.MonadTell,
    MonadWriter: Control_Monad_Writer_Class.MonadWriter,
    censor: Control_Monad_Writer_Class.censor,
    listen: Control_Monad_Writer_Class.listen,
    listens: Control_Monad_Writer_Class.listens,
    pass: Control_Monad_Writer_Class.pass,
    tell: Control_Monad_Writer_Class.tell,
    WriterT: Control_Monad_Writer_Trans.WriterT,
    MonadTrans: Control_Monad_Writer_Trans.MonadTrans,
    execWriterT: Control_Monad_Writer_Trans.execWriterT,
    lift: Control_Monad_Writer_Trans.lift,
    mapWriterT: Control_Monad_Writer_Trans.mapWriterT,
    runWriterT: Control_Monad_Writer_Trans.runWriterT
};

